var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareandcoachWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "careandcoach_white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 163.327,
    height: 55.183,
    viewBox: "0 0 163.327 55.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_3338",
    "data-name": "Rechteck 3338",
    width: 163.327,
    height: 55.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_3327",
    "data-name": "Rechteck 3327",
    width: 4.069,
    height: 4.069,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_3329",
    "data-name": "Rechteck 3329",
    width: 2.303,
    height: 2.303,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5050",
    "data-name": "Gruppe 5050",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5049",
    "data-name": "Gruppe 5049",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5048",
    "data-name": "Gruppe 5048",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5567",
    "data-name": "Pfad 5567",
    d: "M157.577.769V54.962a.413.413,0,1,0,.825,0V.769a.413.413,0,0,0-.825,0",
    transform: "translate(-88.224 -0.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5568",
    "data-name": "Pfad 5568",
    d: "M197.693,102.961l-2.947,6.777a.094.094,0,0,0,.085.133h1.388l.1-.057.6-1.369.1-.057h2.453l.085.057.608,1.369.086.057h1.4a.094.094,0,0,0,.085-.133l-2.947-6.777-.1-.057h-.894Zm1.188,4.335h-1.3a.1.1,0,0,1-.1-.133l.665-1.654a.091.091,0,0,1,.171.01l.656,1.644a.1.1,0,0,1-.1.133m13.016,2.443c-.742-.865-1.949-2.31-2.738-3.251l-.019-.133,2.719-3.3a.088.088,0,0,0-.066-.152h-1.654l-.1.066c-.684.837-1.483,1.778-2.177,2.643l-.1.066h-.01l-.066-.066V103a.09.09,0,0,0-.1-.1h-1.293a.09.09,0,0,0-.095.1v6.778a.09.09,0,0,0,.095.1h1.293a.09.09,0,0,0,.1-.1V107.22l.057-.057h.01l.076.038,2.243,2.633.076.038H211.8c.085,0,.152-.066.1-.133m7.318-6.777-2.947,6.777a.094.094,0,0,0,.086.133h1.388l.1-.057.6-1.369.1-.057h2.452l.086.057.608,1.369.085.057h1.4a.094.094,0,0,0,.086-.133l-2.947-6.777-.1-.057h-.893ZM220.4,107.3h-1.3a.1.1,0,0,1-.1-.133l.665-1.654a.091.091,0,0,1,.171.01l.656,1.644a.1.1,0,0,1-.1.133m9.571,2.576a3.485,3.485,0,1,0-.018-6.968h-1.987a.09.09,0,0,0-.1.1v6.778a.09.09,0,0,0,.1.1Zm-.627-1.578v-3.8a.09.09,0,0,1,.095-.1h.514a1.941,1.941,0,0,1,2.082,1.968,1.969,1.969,0,0,1-2.063,2.025h-.532a.09.09,0,0,1-.095-.1m12.828-2.614h-2.263a.09.09,0,0,1-.1-.1v-1.093a.09.09,0,0,1,.1-.1h3.451a.09.09,0,0,0,.1-.1V103a.09.09,0,0,0-.1-.1H238.44a.09.09,0,0,0-.1.1v6.778a.09.09,0,0,0,.1.1h4.924a.09.09,0,0,0,.1-.1v-1.3a.09.09,0,0,0-.1-.1h-3.451a.09.09,0,0,1-.1-.1v-1.017a.09.09,0,0,1,.1-.1h2.263a.09.09,0,0,0,.1-.1v-1.3a.09.09,0,0,0-.1-.1m7.8-2.776h-1.027a.1.1,0,0,0-.095.085l-.732,6.778a.1.1,0,0,0,.1.1h1.322a.1.1,0,0,0,.1-.086l.4-3.945a.093.093,0,0,1,.171-.038l1.17,1.72.076.038h.818l.076-.038,1.169-1.7a.09.09,0,0,1,.171.038l.4,3.926a.1.1,0,0,0,.1.086h1.321a.1.1,0,0,0,.1-.1l-.731-6.778a.1.1,0,0,0-.1-.085h-1.026l-.076.038-1.73,2.566a.089.089,0,0,1-.152,0l-1.73-2.566Zm11.853,6.873V103a.09.09,0,0,0-.1-.1h-1.293a.09.09,0,0,0-.1.1v6.778a.09.09,0,0,0,.1.1h1.293a.09.09,0,0,0,.1-.1m8.719-4.1H268.28a.09.09,0,0,1-.1-.1v-1.093a.09.09,0,0,1,.1-.1h3.451a.09.09,0,0,0,.1-.1V103a.09.09,0,0,0-.1-.1h-4.924a.09.09,0,0,0-.1.1v6.778a.09.09,0,0,0,.1.1h4.924a.09.09,0,0,0,.1-.1v-1.3a.09.09,0,0,0-.1-.1H268.28a.09.09,0,0,1-.1-.1v-1.017a.09.09,0,0,1,.1-.1h2.263a.09.09,0,0,0,.1-.1v-1.3a.09.09,0,0,0-.1-.1",
    transform: "translate(-109.029 -57.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5569",
    "data-name": "Pfad 5569",
    d: "M202.911,70.974A7.5,7.5,0,0,0,208.023,69a.2.2,0,0,0,.037-.258l-1.366-1.68c-.055-.074-.148-.129-.222-.055a5.032,5.032,0,0,1-3.561,1.458c-2.436,0-3.986-1.882-3.986-4.337,0-2.436,1.55-4.318,3.986-4.318a4.624,4.624,0,0,1,3.469,1.587.167.167,0,0,0,.24-.055l1.44-1.606a.179.179,0,0,0-.018-.258c-1.938-1.7-3.267-2.178-5.131-2.178-4.042,0-6.459,2.953-6.459,6.828,0,4.134,2.639,6.847,6.459,6.847m15.7-.055c4.06,0,6.071-3.377,6.071-6.755,0-3.4-2.03-6.773-6.108-6.773-4.042,0-6.072,3.377-6.072,6.754,0,3.4,2.03,6.773,6.108,6.773m-.092-11c2.436,0,3.6,2.085,3.6,4.208,0,2.141-1.2,4.263-3.506,4.263-2.418,0-3.58-2.1-3.58-4.189,0-2.141,1.181-4.282,3.488-4.282M234.271,57.5,228.55,70.66a.182.182,0,0,0,.165.258h2.307a.244.244,0,0,0,.184-.111l1.2-2.749a.242.242,0,0,1,.184-.111h5.241a.244.244,0,0,1,.166.111l1.218,2.749a.248.248,0,0,0,.166.111h2.326a.182.182,0,0,0,.165-.258L236.154,57.5a.246.246,0,0,0-.185-.11h-1.513a.245.245,0,0,0-.184.11m2.547,8.563h-3.23a.176.176,0,0,1-.165-.258l1.624-3.968a.173.173,0,0,1,.332,0l1.605,3.968a.175.175,0,0,1-.165.258m15.212,4.909A7.5,7.5,0,0,0,257.142,69a.194.194,0,0,0,.037-.258l-1.365-1.68c-.055-.074-.147-.129-.221-.055a5.034,5.034,0,0,1-3.562,1.458c-2.436,0-3.986-1.882-3.986-4.337,0-2.436,1.551-4.318,3.986-4.318A4.622,4.622,0,0,1,255.5,61.4a.168.168,0,0,0,.241-.055l1.439-1.606a.178.178,0,0,0-.018-.258c-1.938-1.7-3.267-2.178-5.131-2.178-4.041,0-6.458,2.953-6.458,6.828,0,4.134,2.639,6.847,6.458,6.847M272.7,57.391h-2.141a.174.174,0,0,0-.185.184v5.2a.174.174,0,0,1-.184.185h-5.131a.175.175,0,0,1-.184-.185v-5.2a.174.174,0,0,0-.184-.184h-2.141a.174.174,0,0,0-.185.184V70.734a.175.175,0,0,0,.185.184h2.141a.174.174,0,0,0,.184-.184V65.678a.175.175,0,0,1,.184-.185h5.131a.174.174,0,0,1,.184.185v5.057a.175.175,0,0,0,.185.184H272.7a.174.174,0,0,0,.184-.184V57.576a.174.174,0,0,0-.184-.184",
    transform: "translate(-109.989 -32.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5570",
    "data-name": "Pfad 5570",
    d: "M356.9,19.132c-.424-.443-.831-.9-1.329-1.458a.167.167,0,0,1-.055-.184,13.452,13.452,0,0,0,1.255-4.245c.018-.129-.055-.277-.166-.277l-1.772-.018a.167.167,0,0,0-.184.147A13.848,13.848,0,0,1,354,15.57a.162.162,0,0,1-.3.037l-3.266-3.6-.5-.554a1.337,1.337,0,0,1-.35-.83,1.3,1.3,0,0,1,1.236-1.292,1.925,1.925,0,0,1,1.347.739.2.2,0,0,0,.277.018l1.255-1.255a.225.225,0,0,0-.018-.3,3.887,3.887,0,0,0-2.86-1.347,3.411,3.411,0,0,0-3.377,3.414,3.177,3.177,0,0,0,.775,2.085.251.251,0,0,1-.055.314,3.959,3.959,0,0,0-2.325,3.543,4.986,4.986,0,0,0,.074,1.052,4.065,4.065,0,0,0,4.245,3.119,5.7,5.7,0,0,0,3.783-1.329.225.225,0,0,1,.3-.018l1.107,1.218a.178.178,0,0,0,.258,0l1.292-1.181a.2.2,0,0,0,0-.277m-4.41-1.384a3.926,3.926,0,0,1-2.325.831c-1.181,0-2.2-.628-2.2-1.808,0-1.052.775-1.661,1.716-2.141a.227.227,0,0,1,.24.037l2.6,2.805a.187.187,0,0,1-.037.277",
    transform: "translate(-193.627 -4.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5571",
    "data-name": "Pfad 5571",
    d: "M202.91,20.657a7.5,7.5,0,0,0,5.112-1.975.2.2,0,0,0,.037-.258l-1.366-1.68c-.055-.074-.148-.129-.222-.055a5.03,5.03,0,0,1-3.561,1.458c-2.436,0-3.986-1.882-3.986-4.337,0-2.436,1.55-4.318,3.986-4.318a4.625,4.625,0,0,1,3.469,1.587.166.166,0,0,0,.24-.055l1.44-1.606a.179.179,0,0,0-.018-.258c-1.938-1.7-3.267-2.178-5.131-2.178-4.042,0-6.459,2.953-6.459,6.828,0,4.134,2.639,6.847,6.459,6.847M218.331,7.185,212.61,20.343a.182.182,0,0,0,.166.258h2.307a.245.245,0,0,0,.185-.111l1.2-2.749a.245.245,0,0,1,.184-.111h5.241a.245.245,0,0,1,.166.111l1.218,2.749a.245.245,0,0,0,.166.111h2.325a.182.182,0,0,0,.166-.258L220.213,7.185a.244.244,0,0,0-.184-.111h-1.513a.245.245,0,0,0-.185.111m2.547,8.563h-3.23a.176.176,0,0,1-.166-.258l1.624-3.968a.173.173,0,0,1,.332,0l1.606,3.968a.176.176,0,0,1-.166.258M233.4,20.417V17.1a.174.174,0,0,1,.184-.184h.2c.277,0,1.162.018,1.79-.037.055,0,.147.092.166.147a11.679,11.679,0,0,0,2.547,3.506l.147.074H240.8c.185,0,.314-.129.185-.258a16.28,16.28,0,0,1-2.824-3.894c-.037-.074-.055-.221.018-.258a4.722,4.722,0,0,0,2.565-4.208c0-3.34-2.584-4.909-5.684-4.909H231.08a.175.175,0,0,0-.185.185V20.417a.175.175,0,0,0,.185.185h2.141a.175.175,0,0,0,.184-.185m0-6.219V9.768a.174.174,0,0,1,.184-.184h1.477c1.7,0,3.174.775,3.174,2.4,0,1.68-1.55,2.4-3.064,2.4h-1.587a.174.174,0,0,1-.184-.184m20.071-1.55h-4.558a.174.174,0,0,1-.184-.185V9.787a.174.174,0,0,1,.184-.184h6.939a.174.174,0,0,0,.184-.184V7.259a.174.174,0,0,0-.184-.185h-9.449a.175.175,0,0,0-.184.185V20.417a.175.175,0,0,0,.184.185h9.449a.174.174,0,0,0,.184-.185V18.258a.174.174,0,0,0-.184-.185h-6.939a.174.174,0,0,1-.184-.184V15.36a.174.174,0,0,1,.184-.184h4.558a.174.174,0,0,0,.184-.184V12.832a.174.174,0,0,0-.184-.184",
    transform: "translate(-109.988 -3.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5572",
    "data-name": "Pfad 5572",
    d: "M35.345,13.257a3.838,3.838,0,1,0-3.838-3.838,3.838,3.838,0,0,0,3.838,3.838",
    transform: "translate(-17.64 -3.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5573",
    "data-name": "Pfad 5573",
    d: "M82.188,15.7a3.838,3.838,0,1,0-3.838-3.838A3.838,3.838,0,0,0,82.188,15.7",
    transform: "translate(-43.866 -4.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5574",
    "data-name": "Pfad 5574",
    d: "M102.383,30.7a3.838,3.838,0,1,0-3.838-3.838,3.838,3.838,0,0,0,3.838,3.838",
    transform: "translate(-55.173 -12.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5575",
    "data-name": "Pfad 5575",
    d: "M11.686,33.141A3.838,3.838,0,1,0,7.848,29.3a3.839,3.839,0,0,0,3.838,3.838",
    transform: "translate(-4.394 -14.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5576",
    "data-name": "Pfad 5576",
    d: "M7.824,66.4a3.838,3.838,0,1,0-3.838-3.838A3.839,3.839,0,0,0,7.824,66.4",
    transform: "translate(-2.232 -32.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5577",
    "data-name": "Pfad 5577",
    d: "M55.716,14.359a2.034,2.034,0,1,0-2.034-2.034,2.034,2.034,0,0,0,2.034,2.034",
    transform: "translate(-30.055 -5.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5020",
    "data-name": "Gruppe 5020",
    transform: "translate(23.621 46.464)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5019",
    "data-name": "Gruppe 5019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5018",
    "data-name": "Gruppe 5018",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5578",
    "data-name": "Pfad 5578",
    d: "M55.7,109.64a2.034,2.034,0,1,1,2.034-2.034A2.034,2.034,0,0,1,55.7,109.64",
    transform: "translate(-53.67 -105.571)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5023",
    "data-name": "Gruppe 5023",
    transform: "translate(36.288 43.777)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5022",
    "data-name": "Gruppe 5022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5021",
    "data-name": "Gruppe 5021",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5579",
    "data-name": "Pfad 5579",
    d: "M84.483,103.535a2.034,2.034,0,1,1,2.034-2.034,2.034,2.034,0,0,1-2.034,2.034",
    transform: "translate(-82.449 -99.466)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5026",
    "data-name": "Gruppe 5026",
    transform: "translate(12.715 11.668)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5025",
    "data-name": "Gruppe 5025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5024",
    "data-name": "Gruppe 5024",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5580",
    "data-name": "Pfad 5580",
    d: "M30.042,28.814a1.151,1.151,0,1,1,1.151-1.151,1.152,1.152,0,0,1-1.151,1.151",
    transform: "translate(-28.89 -26.511)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5581",
    "data-name": "Pfad 5581",
    d: "M24.809,45.209a1.151,1.151,0,1,0-1.151-1.151,1.151,1.151,0,0,0,1.151,1.151",
    transform: "translate(-13.246 -24.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5029",
    "data-name": "Gruppe 5029",
    transform: "translate(41.069 15.506)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5028",
    "data-name": "Gruppe 5028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5027",
    "data-name": "Gruppe 5027",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5582",
    "data-name": "Pfad 5582",
    d: "M94.463,37.535a1.151,1.151,0,1,1,1.152-1.151,1.151,1.151,0,0,1-1.152,1.151",
    transform: "translate(-93.312 -35.232)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5032",
    "data-name": "Gruppe 5032",
    transform: "translate(49.897 37.636)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5031",
    "data-name": "Gruppe 5031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5030",
    "data-name": "Gruppe 5030",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5583",
    "data-name": "Pfad 5583",
    d: "M114.521,87.816a1.152,1.152,0,1,1,1.151-1.152,1.152,1.152,0,0,1-1.151,1.152",
    transform: "translate(-113.37 -85.513)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5584",
    "data-name": "Pfad 5584",
    d: "M16.545,95.806a3.838,3.838,0,1,0-3.838-3.838,3.838,3.838,0,0,0,3.838,3.838",
    transform: "translate(-7.114 -49.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5585",
    "data-name": "Pfad 5585",
    d: "M69.368,113.248a3.838,3.838,0,1,0-3.838-3.838,3.839,3.839,0,0,0,3.838,3.838",
    transform: "translate(-36.689 -59.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5586",
    "data-name": "Pfad 5586",
    d: "M39.219,115.615a3.838,3.838,0,1,0-3.838-3.838,3.839,3.839,0,0,0,3.838,3.838",
    transform: "translate(-19.809 -60.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5587",
    "data-name": "Pfad 5587",
    d: "M99.629,95.806a3.838,3.838,0,1,0-3.838-3.838,3.838,3.838,0,0,0,3.838,3.838",
    transform: "translate(-53.631 -49.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5588",
    "data-name": "Pfad 5588",
    d: "M89.231,31.256A1.151,1.151,0,1,0,88.08,30.1a1.151,1.151,0,0,0,1.151,1.151",
    transform: "translate(-49.314 -16.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5589",
    "data-name": "Pfad 5589",
    d: "M102.063,16.6a1.151,1.151,0,1,0-1.151-1.151,1.151,1.151,0,0,0,1.151,1.151",
    transform: "translate(-56.498 -8.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5590",
    "data-name": "Pfad 5590",
    d: "M3.767,50.94a1.151,1.151,0,1,0-1.151-1.151A1.151,1.151,0,0,0,3.767,50.94",
    transform: "translate(-1.465 -27.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5591",
    "data-name": "Pfad 5591",
    d: "M22.579,78.473a1.151,1.151,0,1,0-1.151-1.151,1.151,1.151,0,0,0,1.151,1.151",
    transform: "translate(-11.997 -42.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5592",
    "data-name": "Pfad 5592",
    d: "M96.83,111.014a1.151,1.151,0,1,0-1.151-1.151,1.152,1.152,0,0,0,1.151,1.151",
    transform: "translate(-53.568 -60.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5593",
    "data-name": "Pfad 5593",
    d: "M88.222,116.595a1.151,1.151,0,1,0-1.151-1.151,1.151,1.151,0,0,0,1.151,1.151",
    transform: "translate(-48.749 -63.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5594",
    "data-name": "Pfad 5594",
    d: "M89.231,90.956A1.151,1.151,0,1,0,88.08,89.8a1.151,1.151,0,0,0,1.151,1.151",
    transform: "translate(-49.314 -49.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5595",
    "data-name": "Pfad 5595",
    d: "M58.833,122.45a1.152,1.152,0,1,0-1.152-1.152,1.152,1.152,0,0,0,1.152,1.152",
    transform: "translate(-32.294 -67.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5596",
    "data-name": "Pfad 5596",
    d: "M33.916,103.775a1.152,1.152,0,1,0-1.151-1.151,1.152,1.152,0,0,0,1.151,1.151",
    transform: "translate(-18.344 -56.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5035",
    "data-name": "Gruppe 5035",
    transform: "translate(3.29 36.715)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5034",
    "data-name": "Gruppe 5034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5033",
    "data-name": "Gruppe 5033",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5597",
    "data-name": "Pfad 5597",
    d: "M8.626,85.723a1.152,1.152,0,1,1,1.151-1.152,1.152,1.152,0,0,1-1.151,1.152",
    transform: "translate(-7.475 -83.42)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5038",
    "data-name": "Gruppe 5038",
    transform: "translate(8.828 22.558)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5037",
    "data-name": "Gruppe 5037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5036",
    "data-name": "Gruppe 5036",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5598",
    "data-name": "Pfad 5598",
    d: "M21.209,53.556A1.151,1.151,0,1,1,22.36,52.4a1.152,1.152,0,0,1-1.151,1.151",
    transform: "translate(-20.057 -51.253)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5599",
    "data-name": "Pfad 5599",
    d: "M69.908,18.349A1.151,1.151,0,1,0,68.757,17.2a1.151,1.151,0,0,0,1.151,1.151",
    transform: "translate(-38.495 -8.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5600",
    "data-name": "Pfad 5600",
    d: "M54.223,2.3a1.151,1.151,0,1,0-1.151-1.151A1.151,1.151,0,0,0,54.223,2.3",
    transform: "translate(-29.714 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5601",
    "data-name": "Pfad 5601",
    d: "M75.265,4.321a1.151,1.151,0,1,0-1.151-1.151,1.151,1.151,0,0,0,1.151,1.151",
    transform: "translate(-41.495 -1.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5041",
    "data-name": "Gruppe 5041",
    transform: "translate(27.958 3.136)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5040",
    "data-name": "Gruppe 5040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5039",
    "data-name": "Gruppe 5039",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5602",
    "data-name": "Pfad 5602",
    d: "M64.676,9.429a1.151,1.151,0,1,1,1.151-1.151,1.152,1.152,0,0,1-1.151,1.151",
    transform: "translate(-63.524 -7.126)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5044",
    "data-name": "Gruppe 5044",
    transform: "translate(10.412 47.846)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5043",
    "data-name": "Gruppe 5043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5042",
    "data-name": "Gruppe 5042",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5603",
    "data-name": "Pfad 5603",
    d: "M24.809,111.013a1.152,1.152,0,1,1,1.151-1.151,1.151,1.151,0,0,1-1.151,1.151",
    transform: "translate(-23.658 -108.71)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5604",
    "data-name": "Pfad 5604",
    d: "M1.151,75.856A1.152,1.152,0,1,0,0,74.7a1.152,1.152,0,0,0,1.151,1.152",
    transform: "translate(0 -41.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5047",
    "data-name": "Gruppe 5047",
    transform: "translate(9.431 4.759)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5046",
    "data-name": "Gruppe 5046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5045",
    "data-name": "Gruppe 5045",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5605",
    "data-name": "Pfad 5605",
    d: "M22.579,13.116a1.152,1.152,0,1,1,1.151-1.151,1.151,1.151,0,0,1-1.151,1.151",
    transform: "translate(-21.428 -10.813)",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareandcoachWhite);
export default __webpack_public_path__ + "static/media/careandcoach_white.275c514b744b917ffc28c42027fa5977.svg";
export { ForwardRef as ReactComponent };